import {
  CbColorBackgroundInteractiveMainBase,
  CbColorPrimitiveWhite,
  CbShadowNone
} from '@coolblue-development/design-tokens';
import { Chip } from '@coolblue-development/freddy';
import { SmileHappy } from '@coolblue-development/icons';

export const InternalChip = () => {
  return (
    <Chip
      startIcon={<SmileHappy />}
      sx={{
        backgroundColor: CbColorBackgroundInteractiveMainBase,
        color: CbColorPrimitiveWhite,
        borderColor: CbColorBackgroundInteractiveMainBase,
        boxShadow: CbShadowNone
      }}
    >
      Alleen voor Coolblue'ers
    </Chip>
  );
};
